// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2w-tk","productName":"Table_productName__3B5r8"};